@if (isForbidLoading || isDepositForbid) {
  <deposit-withdraw-forbid [isLoading]="isForbidLoading"></deposit-withdraw-forbid>
} @else {
  <div class="scroll-cont">
    <div class="section">
      <div class="cont">
        <div class="row">
          <!-- 選擇bonus -->
          <div class="item">
            <app-deposit-bonus-dropdown
              [currentCurrency]="currentCurrency"
              (bonusLoadingChange)="bonusLoading = $event"
            ></app-deposit-bonus-dropdown>
          </div>
        </div>
        <div class="row">
          <!-- 選擇幣別 -->
          <div class="item">
            <div class="label">
              <span>Select currency</span>
            </div>

            <cs-select
              [(value)]="currentCurrency"
              [options]="cryptoList"
              [disabled]="!isAllLoaded() || cryptoList.length == 0"
              (valueChange)="currencyChange()"
            ></cs-select>
          </div>
          <!-- 選擇網路 -->
          <div class="item">
            <div class="label">
              <span>Select network</span>
            </div>
            <cs-select
              [(value)]="selectedNetwork"
              [options]="networkList"
              [disabled]="!isAllLoaded() || networkList.length == 0"
              (valueChange)="networkChange()"
            ></cs-select>
          </div>
        </div>
        <!-- 這邊有特殊的樣式 所以多加一個item-address-copy -->
        @if (depositAddress && this.isAllLoaded()) {
          <div class="row">
            <div class="item">
              <div class="label">
                <span
                  >Deposit <em>{{ currentCurrency }}</em> to this address</span
                >
              </div>
              <div class="address-cont" (click)="copyDepositAddress()">
                <div class="address-copy-item">
                  <span class="address-container">
                    <span class="address-front">{{ depositAddress.address.slice(0, -5) }}</span>
                    <span class="address-tail">{{ depositAddress.address.slice(-5) }}</span>
                  </span>
                  <i class="fi-clipboard"></i>
                </div>
                <cs-button
                  (buttonClick)="goToAddressQr()"
                  [iconLeft]="'fi-qrcode'"
                  [iconType]="'icon'"
                  [color]="'secondary'"
                  [size]="'large'"
                  [width]="'48px'"
                  [height]="'48px'"
                ></cs-button>
              </div>
              @if (hint) {
                <div class="field-hint">
                  {{ hint }}
                </div>
              }
            </div>
          </div>
        }
        <div class="row">
          <div class="item">
            <cs-button
              (buttonClick)="copyDepositAddress()"
              label="Copy deposit address"
              color="accent"
              size="large"
              [loading]="depositAddress == null || !this.isAllLoaded()"
            ></cs-button>
            @if (depositAddress && this.isAllLoaded()) {
              <div class="confirm-note-list">
                <div class="confirm-note-item">
                  <i class="icon" class="fi-exclamation-circle-filled"></i>
                  <p>
                    Send
                    <span class="mark">{{ depositAddress.token }}</span>
                    via the
                    <span class="mark">
                      @for (item of networkList; track $index) {
                        @if (item.value === selectedNetwork) {
                          {{ item.label }}
                        }
                      }
                    </span>
                    network only
                  </p>
                </div>
                <div class="confirm-note-item">
                  <i class="icon" class="fi-exclamation-circle-filled"></i>
                  <p>
                    The minimum deposit amount is
                    <span class="mark">
                      {{ depositAddress.minDeposit | number: '1.0-20' }} {{ depositAddress.token }}
                    </span>
                  </p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="note">
        <span>Don’t have any crypto yet?</span>
        <cs-button
          (buttonClick)="walletService.jump('deposit', 'buyCrypto')"
          color="secondary"
          width="auto"
          size="small"
          label="Card deposit"
        ></cs-button>
      </div>
    </div>
  </div>
}
